var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.company.TrustedSource && !_vm.offerRequest
        ? _c("authentication", {
            attrs: {
              "test-mode": _vm.contract.TestMode,
              "show-authentication": _vm.showAuthentication
            },
            on: { authenticate: _vm.authenticate }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.company.TrustedSource || _vm.offerRequest
        ? _c(
            "div",
            [
              [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "6", md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-0",
                            attrs: {
                              "label-cols-sm": "12",
                              "label-cols-md": "12",
                              "label-cols-lg": "12"
                            }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "font-weight-bold pt-0",
                                attrs: {
                                  for: "company_information_businessid_field"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("Y-tunnus")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "validated-form-group",
                          {
                            attrs: {
                              "validation-id": "BusinessId",
                              "validation-errors": _vm.validationErrors
                            }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "new-contract-value",
                                  rawName: "v-new-contract-value"
                                }
                              ],
                              staticClass: "form-control contract-field",
                              attrs: {
                                type: "text",
                                id: "company_information_businessid_field",
                                name: "BusinessId",
                                maxlength: "20",
                                value: _vm.company.BusinessId
                              },
                              on: { "value-updated": _vm.valueUpdated }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "6", md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-0",
                            attrs: {
                              "label-cols-sm": "12",
                              "label-cols-md": "12",
                              "label-cols-lg": "12"
                            }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "font-weight-bold pt-0",
                                attrs: { for: "company_information_name_field" }
                              },
                              [_vm._v(_vm._s(_vm.$t("Yrityksen nimi")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "validated-form-group",
                          {
                            attrs: {
                              "validation-id": "CompanyName",
                              "validation-errors": _vm.validationErrors
                            }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "new-contract-value",
                                  rawName: "v-new-contract-value"
                                }
                              ],
                              staticClass: "form-control contract-field",
                              attrs: {
                                type: "text",
                                id: "company_information_name_field",
                                name: "CompanyName",
                                maxlength: "80",
                                value: _vm.company.CompanyName
                              },
                              on: { "value-updated": _vm.valueUpdated }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "6", md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-0",
                            attrs: {
                              "label-cols-sm": "12",
                              "label-cols-md": "12",
                              "label-cols-lg": "12"
                            }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "font-weight-bold pt-0",
                                attrs: {
                                  for: "company_information_phone_field"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("Puhelinnumero")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "validated-form-group",
                          {
                            attrs: {
                              "validation-id": "CompanyPhone",
                              "validation-errors": _vm.validationErrors
                            }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "new-contract-value",
                                  rawName: "v-new-contract-value"
                                }
                              ],
                              attrs: {
                                type: "text",
                                id: "company_information_phone_field",
                                name: "CompanyPhone",
                                value: _vm.company.Phone
                                  ? _vm.company.Phone
                                  : "+358"
                              },
                              on: { "value-updated": _vm.valueUpdated }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "6", md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-0",
                            attrs: {
                              "label-cols-sm": "12",
                              "label-cols-md": "12",
                              "label-cols-lg": "12"
                            }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "font-weight-bold pt-0",
                                attrs: { id: "company_information_email_field" }
                              },
                              [_vm._v(_vm._s(_vm.$t("Sähköpostiosoite")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "validated-form-group",
                          {
                            attrs: {
                              "validation-id": "CompanyEmail",
                              "validation-errors": _vm.validationErrors
                            }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "new-contract-value",
                                  rawName: "v-new-contract-value"
                                }
                              ],
                              attrs: {
                                type: "email",
                                id: "company_information_email_field",
                                name: "CompanyEmail",
                                value: _vm.company.Email
                              },
                              on: { "value-updated": _vm.valueUpdated }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.offerRequest
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "6", md: "4" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "font-weight-bold pt-0",
                                    attrs: {
                                      for:
                                        "company_information_contactperson_firstname_field"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Yhteyshenkilön etunimi"))
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "validated-form-group",
                              {
                                attrs: {
                                  "validation-id": "FirstName__contactperson-1",
                                  "validation-errors": _vm.validationErrors
                                }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "new-contract-value",
                                      rawName: "v-new-contract-value"
                                    }
                                  ],
                                  attrs: {
                                    type: "text",
                                    id:
                                      "company_information_contactperson_firstname_field",
                                    name: "FirstName__contactperson-1",
                                    maxlength: "50",
                                    value: _vm.contactPersonFirstName
                                  },
                                  on: { "value-updated": _vm.valueUpdated }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "6", md: "4" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "font-weight-bold pt-0",
                                    attrs: {
                                      for:
                                        "company_information_contactperson_lastname_field"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Yhteyshenkilön sukunimi"))
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "validated-form-group",
                              {
                                attrs: {
                                  "validation-id": "LastName__contactperson-1",
                                  "validation-errors": _vm.validationErrors
                                }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "new-contract-value",
                                      rawName: "v-new-contract-value"
                                    }
                                  ],
                                  attrs: {
                                    type: "text",
                                    id:
                                      "company_information_contactperson_lastname_field",
                                    name: "LastName__contactperson-1",
                                    maxlength: "50",
                                    value: _vm.contactPersonLastName
                                  },
                                  on: { "value-updated": _vm.valueUpdated }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.offerRequest
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "6", md: "4" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "font-weight-bold pt-0" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Yhteyshenkilön puhelinnumero")
                                      )
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "validated-form-group",
                              {
                                attrs: {
                                  "validation-id": "Phone__contactperson-1",
                                  "validation-errors": _vm.validationErrors
                                }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "new-contract-value",
                                      rawName: "v-new-contract-value"
                                    }
                                  ],
                                  attrs: {
                                    type: "text",
                                    name: "Phone__contactperson-1",
                                    maxlength: "50",
                                    value: _vm.contactPersonPhone
                                  },
                                  on: { "value-updated": _vm.valueUpdated }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "6", md: "4" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "font-weight-bold pt-0" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Yhteyshenkilön sähköpostiosoite"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "validated-form-group",
                              {
                                attrs: {
                                  "validation-id": "Email__contactperson-1",
                                  "validation-errors": _vm.validationErrors
                                }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "new-contract-value",
                                      rawName: "v-new-contract-value"
                                    }
                                  ],
                                  attrs: {
                                    type: "text",
                                    name: "Email__contactperson-1",
                                    maxlength: "100",
                                    value: _vm.contactPersonEmail
                                  },
                                  on: { "value-updated": _vm.valueUpdated }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }